// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__EnWfa","label":"Radio_label__1t_t3","checkMark":"Radio_checkMark__3xlH0","disabled":"Radio_disabled__yWG2r"};